import { mainService, transactionService, baseUrlService } from '@/utils/request'

// 作品管理相关接口

// 图片上传接口
export function addPictrues (data, vm, item) {
  return mainService({
    url: 'app/publish/publish_file',
    method: 'post',
    data: data,
    onUploadProgress: function (progressEvent) { // 原生获取上传进度的事件
      if (progressEvent.lengthComputable) {
        // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
        // 如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
        var data = Math.floor((progressEvent.loaded / progressEvent.total) * 100)
        if (item) {
          if (data === 100) {
            vm.$set(item, 'progress', 99)
          } else {
            vm.$set(item, 'progress', data)
          }
        } else {
          if (data === 100) {
            vm.$root.eventHub.$emit('getUploadPicGroupProgress', 99)
          } else {
            vm.$root.eventHub.$emit('getUploadPicGroupProgress', data)
          }
        }
      }
    }
  })
}
// 图组上传接口

export function addPictureGroup (data, vm) {
  return mainService({
    url: 'app/publish/add_pictures',
    method: 'post',
    data: data,
    onUploadProgress: function (progressEvent) { // 原生获取上传进度的事件
      if (progressEvent.lengthComputable) {
        // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
        // 如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
        var data = Math.floor((progressEvent.loaded / progressEvent.total) * 100)
        if (data === 100) {
          vm.$root.eventHub.$emit('getUploadPicGroupProgress', 99)
        } else {
          vm.$root.eventHub.$emit('getUploadPicGroupProgress', data)
        }
      }
    }
  })
}

// 删除图片
/**
 *
 * @param {
 *  pic_id: string
 * } data
 * @returns
 */
export function deletePictrue (data) {
  return mainService({
    url: 'app/publish/del_pic',
    method: 'post',
    data: data
  })
}

// 获取个人作品列表(图组)
export function getAuthorWorksGroupList (data) {
  return mainService({
    url: 'app/person/get_author_works',
    method: 'post',
    data: data
  })
}

// 获取个人作品列表(图片)
/**
 *
 * @param {*}
 * {
 *  type: 1:个人，2：他人
 * }
 * @returns
 */
export function getAuthorWorksListByImage (data) {
  return mainService({
    url: 'gty/get_pic_list_v2',
    method: 'post',
    data: data
  })
}

// 获取图片信息
export function getPictrueDetail (id) {
  return mainService({
    url: `gty/picture_detailed?originId=${id}`,
    method: 'get'
  })
}

// 上架商品
export function shelvesWorks (data) {
  return mainService({
    url: 'gty/shelves_works',
    method: 'post',
    data: data
  })
}

// 出售商品
export function worksSale (data) {
  return mainService({
    url: 'gty/works_sale',
    method: 'post',
    data: data
  })
}

// 获取图片关键词
export function getPicKeyword (id) {
  return mainService({
    url: 'app/publish/get_pic_keyword',
    method: 'post',
    data: {
      pic_id: id
    }
  })
}

// 确认发布信息
export function updateGroupInfo (data) {
  return mainService({
    url: 'app/picture_group/update_group_info',
    method: 'post',
    data: data
  })
}

// 点赞/收藏作品
export function collectWorks (data) {
  return mainService({
    // url: 'gty/coll_pic_gty',
    url: 'app/interaction/coll_works',
    method: 'post',
    data: data
  })
}

// 是否已收藏
export function getWorksIsCollect (data) {
  return mainService({
    url: 'gty/is_coll_gty',
    method: 'post',
    data: data
  })
}

// 获取收藏列表
export function getCollectList (data) {
  return mainService({
    url: 'gty/get_coll_gty',
    method: 'post',
    data: data
  })
}

// 批量取消收藏
export function delCollectionList (data) {
  return mainService({
    url: 'gty/del_coll_list_gty',
    method: 'post',
    data: data
  })
}

// 获取举报信息
export function getReportList (data) {
  return mainService({
    url: 'app/picture_group/list_report',
    method: 'post',
    data: data
  })
}

// 图片举报
export function imageReport (data) {
  return mainService({
    url: 'app/picture_group/to_report',
    method: 'post',
    data: data
  })
}

// 删除图组
export function deletePictrueGroup (id) {
  return mainService({
    url: 'app/picture_group/delete_group',
    method: 'post',
    data: {
      grp_id: id
    }
  })
}

// 置顶作品
export function topOwnerWorks (data) {
  return mainService({
    url: 'gty/top_picture',
    method: 'post',
    data: data
  })
}

// 获取图片出售预设尺寸
export function getImageSpecTemplate () {
  return transactionService({
    url: 'specTemplate/list',
    method: 'get'
  })
}

// 通过图组id获取图片
export function getPictureListByGroupId (data) {
  return mainService({
    url: 'gty/grp_pic_list',
    method: 'post',
    data: data
  })
}
// 设置图组图片封面
export function setPicgroupCover (data) {
  return mainService({
    url: 'gty/set_cover',
    method: 'post',
    data: data
  })
}

// 编辑图组信息
export function editPicgroupInfo (data) {
  return mainService({
    url: 'gty/edit_grp',
    method: 'post',
    data: data
  })
}

// 获取单张图片列表
export function getPicgroupsinglepiclist (data) {
  return mainService({
    url: 'gty/move_pic_list',
    method: 'post',
    data: data
  })
}
// 添加图片到图组
export function addPicgroupPictureFromLocal (data) {
  return mainService({
    url: 'gty/move_pics',
    method: 'post',
    data: data
  })
}

// 删除图组
export function deletePicGroup (data) {
  return mainService({
    url: 'gty/del_grp',
    method: 'post',
    data: data
  })
}

// 添加版权
export function updatePicCopyrightRegister (data) {
  return baseUrlService({
    url: 'guituyun-copyright/outside/addOutsideCopyrightInfo',
    method: 'post',
    data: data
  })
}
// 获取图片版权详情
export function getPicCopyrightRegisterInfo (data) {
  return baseUrlService({
    url: 'guituyun-copyright/outside/getOutsideByImgId' + data,
    method: 'get'
  })
}

export function modifyPicCopyrightRegister (data) {
  return baseUrlService({
    url: 'guituyun-copyright/outside/updateOutsideCopyrightInfo',
    method: 'post',
    data: data
  })
}

// 删除版权
export function deletePicCopyrightRegister (data) {
  return baseUrlService({
    url: 'guituyun-copyright/outside/delByImgId' + data,
    method: 'post'
  })
}

// 仅展示出售
export function onlyshowSale (data) {
  return mainService({
    url: 'gty/show_pic ',
    method: 'post',
    data: data
  })
}

// 仅展示下架
export function offlineShowSale (data) {
  return mainService({
    url: 'gty/offline_pic',
    method: 'post',
    data: data
  })
}

// 获取未读消息数
export function getUnreadMessageInfo (data) {
  return mainService({
    url: 'gty/get_user_amount',
    method: 'post',
    data: data
  })
}
// 消除未读消息
export function removeUnreadMessageInfo (data) {
  return mainService({
    url: 'gty/remove_amount',
    method: 'post',
    data: data
  })
}

// 获取上传地址
export function getUploadOssUrlList (data) {
  return mainService({
    url: 'app/publish/get_put_urls',
    method: 'post',
    data: data
  })
}

// 上传单图回调
export function uploadSinglePicCallback (data) {
  return mainService({
    url: 'app/publish/publish_file_v2',
    method: 'post',
    data: data
  })
}

// 上传组图回调
export function uploadGroupCallback (data) {
  return mainService({
    url: 'app/publish/add_pictures_v2',
    method: 'post',
    data: data
  })
}

// 更新图片（图组）信息
export function uploadGroupinfoV2 (data) {
  return mainService({
    url: 'app/picture_group/update_group_info_v2',
    method: 'post',
    data: data
  })
}
